export default [
  {
    "id": "404",
    "name": "not-found",
    "path": "/404"
  },
  {
    "id": "500",
    "name": "error",
    "path": "/500"
  },
  {
    "id": "registration-success",
    "name": "success",
    "path": "/cadastro-sucesso"
  },
  {
    "id": "your-account",
    "name": "sua-conta",
    "path": "/conta"
  },
  {
    "id": "cards",
    "name": "formas-de-pagamento",
    "path": "/conta/cartoes"
  },
  {
    "id": "identificacao",
    "name": "login",
    "path": "/identificacao"
  },
  {
    "id": "login-to-continue",
    "name": "acesse-e-continue",
    "path": "/acesse-e-continue"
  },
  {
    "id": "register",
    "name": "criar-cadastro",
    "path": "/cadastro"
  },
  {
    "id": "reset-password-identification",
    "name": "reset-password-identification",
    "path": "/recuperar-senha-identificacao"
  },
  {
    "id": "reset-password-identification-hybrid",
    "name": "reset-password-identification",
    "path": "/cliente/recuperar-senha-identificacao"
  },
  {
    "id": "reset-password-otp-phone",
    "name": "recuperar-senha-otp-telefone",
    "path": "/recuperar-senha/telefone"
  },
  {
    "id": "reset-password-otp-phone-hybrid",
    "name": "recuperar-senha-otp-telefone",
    "path": "/cliente/recuperar-senha/telefone"
  },
  {
    "id": "reset-password-otp-email",
    "name": "recuperar-senha-otp-email",
    "path": "/recuperar-senha/email"
  },
  {
    "id": "reset-password-otp-email-hybrid",
    "name": "recuperar-senha-otp-email",
    "path": "/cliente/recuperar-senha/email"
  },
  {
    "id": "password-recovery",
    "name": "password-recovery",
    "path": "/recuperar-senha"
  },
  {
    "id": "password-recovery-hybrid",
    "name": "password-recovery",
    "path": "/cliente/recuperar-senha"
  },
  {
    "id": "reset-password-new-password",
    "name": "reset-password-new-password",
    "path": "/recuperar-senha/nova-senha"
  },
  {
    "id": "reset-password-new-password-hybrid",
    "name": "reset-password-new-password",
    "path": "/cliente/recuperar-senha/nova-senha"
  },
  {
    "id": "reset-password-success",
    "name": "reset-password-success",
    "path": "/recuperar-senha/nova-senha/sucesso"
  },
  {
    "id": "reset-password-success-hybrid",
    "name": "reset-password-success",
    "path": "/cliente/recuperar-senha/nova-senha/sucesso"
  }
]
